import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import closeIcon from "../../Assets/Svg/close-icon.svg";
import viewFile from "../../Assets/Images/Group.svg";
import "./PrDetailsUnderJobs.css";
import DropZone from "../../Components/DropZone/DropZone";
import CustomPopup from "../CustomPopup/CustomPopup";
import areIcon from "../../Assets/Svg/areyousure-icon.svg";
import successIcon from "../../Assets/Svg/success-icon.svg";
import {
  addJobQuotations,
  createJobQuotations,
  fetchPrJobAttachments,
  getS3SignedUrl,
} from "../../Store/Actions/vendor_dashboard";
import PageLoader from "../Pageloader/PageLoader";
import { toast } from "react-toastify";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { compareBiddingDate } from "../../Utils/Utils";
import { fetchSinglePrData } from "../../Store/Actions/vendorJobsAction";
import PDFPreviewModal from "./PdfPreviewModal";
import axios from "axios";

function getGroupName(filterList = {}, groupName) {
  if (!groupName) return null;

  const combinedList = [
    ...(filterList.goods || []),
    ...(filterList.services || []),
    ...(filterList.project || []),
  ];

  const match = combinedList.find(
    (item) => item?.purchasinggroup_name?.trim?.() === groupName.trim()
  );

  return match?.meaning?.trim?.() || null;
}

// CardItem component to represent each card
const CardItem = ({ item }) => {
  const filterList = useSelector(
    (state) => state?.VendorJobsReducer?.filterList
  );
  const meaning = getGroupName(filterList, item?.PrSapDetail?.PR_Group);

  return (
    <div className="pr-combined-detail-card-item">
      {/* Displaying PR_ID */}
      <span className="pr-combined-detail-card-title">PR ID:</span>
      <input
        type="text"
        className="pr-combined-detail-card-content"
        value={item?.PrSapDetail?.PR_ID || ""}
        readOnly
        placeholder="PR ID"
      />

      {/* Displaying PR_Description */}
      <span className="pr-combined-detail-card-title">Description:</span>
      <textarea
        className="pr-combined-detail-card-content"
        value={item?.PrSapDetail?.PR_description_Long || ""}
        readOnly
        placeholder="Description"
      />

      {/* Displaying PR_QTY */}
      <span className="pr-combined-detail-card-title">Quantity:</span>
      <input
        type="text"
        className="pr-combined-detail-card-content"
        value={item?.PrSapDetail?.PR_QTY || ""}
        readOnly
        placeholder="Quantity"
      />

      {/* Displaying PR_Unit */}
      <span className="pr-combined-detail-card-title">Unit:</span>
      <input
        type="text"
        className="pr-combined-detail-card-content"
        value={item?.PrSapDetail?.PR_Unit || ""}
        readOnly
        placeholder="Unit"
      />

      {/* Displaying PR_Company */}
      <span className="pr-combined-detail-card-title">Company:</span>
      <input
        type="text"
        className="pr-combined-detail-card-content"
        value={item?.PrSapDetail?.PR_Company || ""}
        readOnly
        placeholder="Company"
      />

      {/* Displaying PR_Group */}
      <span className="pr-combined-detail-card-title">Group:</span>
      <input
        type="text"
        className="pr-combined-detail-card-content"
        value={meaning || ""}
        readOnly
        placeholder="Group"
      />
    </div>
  );
};

const SinglePrDetailsUnderJobs = ({
  isOpen,
  closeModal,
  formTitle,
  data,
  setSelectedRowData,
  isVendorCodePresent,
}) => {
  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const dispatch = useDispatch();

  const { quotations, attachments, attachmentLoading, attachmentError } =
    useSelector((state) => state.VendorDashboardReducer);
  const { singlePr, loading, error } = useSelector(
    (state) => state.VendorJobsReducer
  );
  const [files, setFiles] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [prData, setPrData] = useState([]);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [uploadEnable, setUploadEnable] = useState(false);
  const [isPdfPreviewOpen, setIsPdfPreviewOpen] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const handleViewAttachments = async () => {
    if (files.length < 1) {
      toast.error("No attachments");
      return;
    }
    const zip = new JSZip();
    const filess = files;
    try {
      const filePromises = filess?.map((url) =>
        fetch(url).then(async (response) => {
          const blob = await response.blob();
          const filename = decodeURIComponent(url.split("/").pop());
          return { blob, filename };
        })
      );
      const downloadedFiles = await Promise.all(filePromises);
      downloadedFiles?.forEach(({ blob, filename }) => {
        zip.file(filename, blob);
      });
      // Generate the zip file
      const zipContent = await zip.generateAsync({ type: "blob" });

      // Trigger the download
      saveAs(zipContent, "attachments.zip");
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
    }
  };

  const checkStatus = () => {
    switch (+data?.Vendor_Status) {
      case 0:
        return true;
      default:
        return false;
    }
  };

  useEffect(() => {
    if (data?.JobId) {
      dispatch(fetchPrJobAttachments(data?.JobId));
      dispatch(fetchSinglePrData(data?.JobId));
    }
    const status = checkStatus();
    if (status) {
      const checkDate = compareBiddingDate(data?.BiddingDate);
      setUploadEnable(checkDate);
    } else {
      setUploadEnable(false);
    }
  }, [data]);

  useEffect(() => {
    if (data?.JobId == singlePr?.PrJobDetails?.JobId) {
      setPrData(singlePr?.PrJobDetails?.JobPrDetails);
    } else {
      setPrData([]);
    }
  }, [singlePr]);

  useEffect(() => {
    if (
      attachments?.data?.prAttachments?.length > 0 ||
      attachments?.data?.PrJobAttachments?.length > 0
    ) {
      if (attachments?.data?.prAttachments?.length > 0) {
        const files = attachments?.data?.prAttachments.split(",");
        setFiles(files);
      }
      if (attachments?.data?.PrJobAttachments?.length > 0) {
        const newFiles = [];
        attachments?.data?.PrJobAttachments?.forEach((attachment) => {
          if (attachment?.JobId === data?.JobId) {
            const file = attachment?.AttachmentFileUrl;
            if (file) {
              newFiles.push(file);
            }
          }
        });
        if (newFiles.length > 0) {
          setFiles((prevFiles) => [...prevFiles, ...newFiles]);
        }
      }
    } else {
      setFiles([]);
    }
  }, [attachments, data?.JobId]);

  const formattedBiddingDate = formatDateForInput(data?.BiddingDate);

  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm();

  const watchedPhoneNo = watch("phoneNo");

  useEffect(() => {
    reset({
      phoneNo: quotations?.QuotationInfo?.phoneNo || "",
    });
  }, [quotations, reset]);

  useEffect(() => {
    const originalPhone = quotations?.QuotationInfo?.phoneNo?.trim() || "";
    const currentPhone = watchedPhoneNo?.trim() || "";
    const filteredNewFiles = (filesToUpload || []).filter((file) => !file?.url);

    const phoneChanged = currentPhone !== originalPhone;
    const filesAdded = filteredNewFiles.length > 0;

    setHasChanges(phoneChanged || filesAdded);
  }, [watchedPhoneNo, filesToUpload, quotations]);

  const onSubmit = (formData, e) => {
    e.preventDefault();

    if (!isVendorCodePresent) {
      toast.error(
        t("You cannot upload a quotation. Please contact the Buyer.")
      );
      return;
    }

    if (!uploadEnable) {
      return;
    }

    if (!hasChanges) {
      toast.error("Please make changes before submitting.");
      return;
    }

    const phoneNumber = formData?.phoneNo;
    const quotationId = quotations?.QuotationInfo?.JobQuotationId;
    const originalPhone = quotations?.QuotationInfo?.phoneNo?.trim();
    const filteredFiles = (filesToUpload || []).filter((file) => !file?.url);

    if (!quotationId) {
      if (filteredFiles.length === 0) {
        toast.error("Please add at least one file before submitting.");
        return;
      }
    } else {
      if (phoneNumber === originalPhone && filteredFiles.length === 0) {
        toast.error(
          "Please add at least one file or change the phone number before submitting."
        );
        return;
      }
    }

    setPhoneNumber(phoneNumber);
    setShowModal(true);
  };

  const uploadFilesToS3 = async (files, jobId) => {
    const uploadedUrls = [];

    for (const file of files) {
      try {
        const signedUrlPayload = {
          module: "Quotation",
          jobId,
          fileName: file.name,
          fileType: file.type,
        };
        const signedUrlResponse = await dispatch(
          getS3SignedUrl(signedUrlPayload)
        );

        const signedUrlData = signedUrlResponse?.payload || signedUrlResponse;

        if (!signedUrlData?.location) {
          throw new Error(`Failed to get signed URL for ${file.name}`);
        }

        const uploadResponse = await axios.put(signedUrlData.location, file, {
          headers: {
            "Content-Type": file.type,
          },
        });

        if (uploadResponse.status !== 200) {
          throw new Error(`Failed to upload ${file.name} to S3`);
        }
        const permanentUrl = signedUrlData.location.split("?")[0];

        uploadedUrls.push({
          fileName: file.name,
          fileUrl: permanentUrl,
          key: signedUrlData.key,
        });
      } catch (error) {
        console.error(`Error uploading ${file.name}:`, error);
        throw new Error(`Failed to upload ${file.name}: ${error.message}`);
      }
    }

    return uploadedUrls;
  };

  const submitQuotation = async () => {
    const quotationId = quotations?.QuotationInfo?.JobQuotationId;

    if (!phoneNumber && !quotationId && filesToUpload.length === 0) {
      toast.error("Please add at least one file before submitting.");
      return;
    }

    const filteredFiles = (filesToUpload || []).filter((file) => !file?.url);

    try {
      if (filteredFiles.length > 0) {
        if (quotations?.QuotationInfo) {
          setShowModal(false);
          const uploadedFiles = await uploadFilesToS3(
            filteredFiles,
            data?.JobId
          );

          const formattedFiles = uploadedFiles.map((file) => ({
            key: file.key,
            location: file.fileUrl,
          }));

          const result = await dispatch(
            addJobQuotations(
              data?.JobId,
              quotationId,
              phoneNumber,
              formattedFiles
            )
          );

          if (result?.success) {
            toast.success(
              "Files uploaded and quotation submitted successfully"
            );
            setFilesToUpload([]);
            closeModal();
          } else {
            toast.error(result?.error || "Failed to submit quotation");
          }
        } else {
          setShowModal(false);
          const result = await dispatch(
            createJobQuotations(data?.JobId, filteredFiles, phoneNumber)
          );
          if (result?.success) {
            setFilesToUpload([]);
            closeModal();
          } else {
            toast.error(result?.error || "Failed to create quotation");
          }
        }
      } else if (
        quotationId &&
        phoneNumber != quotations?.QuotationInfo?.phoneNo
      ) {
        setShowModal(false);
        const result = await dispatch(
          addJobQuotations(data?.JobId, quotationId, phoneNumber, [])
        );

        if (result?.success) {
          toast.success("Phone number updated successfully");
          closeModal();
        } else {
          toast.error(result?.error || "Failed to update phone number");
        }
      }
    } catch (error) {
      setShowModal(false);
      toast.error(error.message || "An error occurred while submitting");
    }
  };

  const closePopup = () => {
    setPhoneNumber(null);
    setFilesToUpload([]);
    setShowModal(false);
  };
  const handleExportPDF = () => {
    if (!singlePr?.PrJobDetails || prData.length === 0) {
      toast.error("No data available to export");
      return;
    }
    setIsPdfPreviewOpen(true);
  };

  return (
    <>
      {(attachmentLoading || loading) && <PageLoader />}

      {showModal && (
        <CustomPopup
          isOpenPopup={showModal}
          closePopup={closePopup}
          title="Are you sure!"
          image={areIcon}
          text={"You want to Apply this Job ?"}
          btn1="Cancel"
          btn2="Confirm"
          successTitle="Done!"
          successText={"Apply Job successfully"}
          successIcon={successIcon}
          btn3="Ok"
          scenarioType="applyProject"
          closePrDetails={closeModal}
          submitAction={submitQuotation}
        />
      )}

      <PDFPreviewModal
        isOpen={isPdfPreviewOpen}
        onClose={() => setIsPdfPreviewOpen(false)}
        data={singlePr?.PrJobDetails}
        t={t}
      />

      <div className="d-flex justify-content-center">
        <Modal
          isOpen={isOpen}
          onRequestClose={closeModal}
          className="pr-details-jobs-user-modal"
          overlayClassName="pr-details-jobs-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <div className="pr-details-jobs-title-div">
            <div className="d-flex">
              {" "}
              <h2 style={{ marginRight: "20px" }}>{formTitle}</h2>
              <div
                className="pr-details-view-file mx-2 px-1"
                onClick={handleViewAttachments}
              >
                <img
                  className="pr-details-view-file-image "
                  src={viewFile}
                  alt=""
                />
                <h5 className="pr-details-view-file-name px-2 pt-2">
                  view attachment file
                </h5>
              </div>
            </div>

            <img
              src={closeIcon}
              alt=""
              onClick={closeModal}
              style={{ cursor: "pointer" }}
            />
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <br />
            <div className="pr-details-pr-title" style={{ width: "100%" }}>
              <div className="pr-details-date-main mb-3">
                <div className="pr-details-bidd-deli-text">
                  <label htmlFor="BiddingEnd">{t("Bidding End")}</label>
                  <br />
                  <input
                    type="date"
                    value={formattedBiddingDate}
                    readOnly
                    placeholder="Select a Date"
                  />
                </div>
                <div className="pr-details-bidd-deli-text">
                  <label>{t("Buyer")}</label>
                  <input
                    type="text"
                    value={data?.BuyerName}
                    readOnly
                    placeholder="Pattarapoom L."
                  />
                </div>
              </div>

              <label htmlFor="PR Title">{t("PR Title")}</label>
              <br />
              <input
                type="text"
                value={data?.PrTitle}
                readOnly
                id="PR Title"
                placeholder=""
              />
            </div>
            <br />
            <div className="pr-details-jobs-main-scroll">
              <div className="pr-details-jobs-main-container">
                <div className="pr-details-jobs-header-wrapper">
                  <div className="pr-details-jobs-header">
                    {t("PR Combined Detail")}
                  </div>
                  <button
                    type="button"
                    className="pr-details-download-pdf-btn"
                    onClick={handleExportPDF}
                  >
                    Export PDF
                  </button>
                </div>

                {prData?.map((item, index) => {
                  return (
                    <div className="pr-details-jobs-card-qtn" key={index}>
                      <CardItem item={item} />
                    </div>
                  );
                })}
              </div>
            </div>

            {/* note */}
            <div className="quotation-pr-title">
              <span className="quotation-pr-note-text">{t("Note")}</span>
              <div className="pr-note-textarea">
                <textarea
                  rows="1"
                  value={data?.Note}
                  readOnly
                  cols="130"
                  placeholder="I"
                />
              </div>
            </div>
            <br />
            <DropZone
              JobId={data?.JobId}
              uploadEnable={uploadEnable}
              onSubmit={(files) => setFilesToUpload(files)}
            />

            {uploadEnable && (
              <div className="pr-details-pr-title" style={{ width: "100%" }}>
                <label htmlFor="Phone Number">
                  {t("Phone Number")}
                  <span className="staricon"> *</span>
                </label>
                <br />
                <input
                  type="text"
                  id="Phone Number"
                  defaultValue={quotations?.QuotationInfo?.phoneNo || ""}
                  {...register("phoneNo", {})}
                />
              </div>
            )}

            <div className="pt-3 create-btns-div">
              <button
                type="button"
                className="pr-details-jobs-submit-btn pr-details-jobs-cancel-btn"
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                type="submit"
                className="pr-details-jobs-submit-btn"
                disabled={!uploadEnable || !hasChanges}
              >
                Submit
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </>
  );
};

export default SinglePrDetailsUnderJobs;
